import { config } from '@app/config';
import * as authTypes from './auth.types';

// SET
export const setNewSignup = (newSignup, customer) => ({
  type: authTypes.SET_NEW_SIGNUP,
  payload: {
    newSignup,
    customer,
  },
});
export const setAuthFormType = (payload) => {
  if (payload === 'login' || payload === 'signup') {
    return {
      type: authTypes.SET_AUTH_FORM_TYPE,
      payload,
    };
  }

  throw new Error('setAuthFormType can only be assigned login/signup');
};

export const authFromCookiesSuccess = (payload) => ({
  type: authTypes.AUTH_FROM_COOKIES_SUCCESS,
  payload,
});
export const authFromCookiesError = () => ({
  type: authTypes.AUTH_FROM_COOKIES_ERROR,
});

// GETME
export const getMeRequest = () => ({
  type: authTypes.GETME_REQUEST,
});
export const getMeSuccess = (payload) => ({
  type: authTypes.GETME_SUCCESS,
  payload,
});
export const getMeFailure = (error) => ({
  type: authTypes.GETME_FAILURE,
  error,
});

// LOGOUTS
export const logOutTry = ({ afterPasswordReset = false } = {}) => ({
  type: authTypes.LOG_OUT_TRY,
  payload: {
    afterPasswordReset,
  },
});

// Auth0
export const authUniversalLogin = (
  defaultTab: string,
  state: Record<string, any> = {},
  connection = config.SERVICES.AUTH0.CONNECTION,
) => ({
  type: authTypes.AUTHO_LOGIN,
  payload: {
    defaultTab,
    state,
    connection,
  },
});

export const authPasswordReset = ({
  email = '',
  isServerResetPassword = false,
} = {}) => ({
  type: authTypes.AUTH0_PASSWORD_RESET,
  payload: {
    email,
    isServerResetPassword,
  },
});
